import React from "react";
import { ExternalLink } from "lucide-react";

export const StreamSection = ({ streamInfo }) => {
    const playerUrl = streamInfo?.player_url || "https://player.kick.com/leonardthepreacher";
    const kickUrl = streamInfo
        ? `https://kick.com/${streamInfo.kick_username}`
        : "https://kick.com/leonardthepreacher";

    return (
        <section
            id="stream"
            data-testid="stream-section"
            className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24"
        >
            <div className="flex items-end justify-between gap-4 mb-6 flex-wrap">
                <div>
                    <p className="font-graffiti text-hotpink text-2xl -rotate-2 mb-1">
                        live now ↓
                    </p>
                    <h2 className="font-anton uppercase text-4xl md:text-6xl text-white leading-none">
                        The <span className="text-kickgreen">Pulpit</span>
                    </h2>
                </div>
                <a
                    data-testid="open-kick-link"
                    href={kickUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center gap-2 font-anton uppercase tracking-wider text-sm border-2 border-white text-white px-4 py-2 hover:bg-white hover:text-black transition-colors"
                >
                    Open on Kick <ExternalLink className="w-4 h-4" />
                </a>
            </div>

            <div className="relative">
                <div
                    aria-hidden
                    className="absolute -top-3 -left-3 w-32 h-3 tape"
                />
                <div
                    aria-hidden
                    className="absolute -bottom-3 -right-3 w-32 h-3 tape"
                />
                <div className="border-4 border-black brutal-shadow-green bg-black aspect-video w-full overflow-hidden">
                    <iframe
                        data-testid="kick-player-iframe"
                        title="Kick Live Stream"
                        src={`${playerUrl}?autoplay=false&muted=true`}
                        allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
                        allowFullScreen
                        className="w-full h-full"
                        style={{ border: 0 }}
                    />
                </div>
                <p className="mt-3 font-chivo text-xs text-white/50 uppercase tracking-widest">
                    Player offline? Stream goes live nightly at 12:00 AM EST.
                </p>
            </div>
        </section>
    );
};
